/* eslint-disable padding-line-between-statements */
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { ClausesComponentVM } from 'ent-components-platform-react';
import { TranslatorContext } from '@jutro/locale';
import { IntlContext } from 'react-intl';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { LoadSaveService } from 'twia-capability-quoteandbind-residential';
import { Currency as CurrencyField } from 'gw-components-platform-react';
import AdditionalPremisesCoverage from '../../../tfpa-capability-quoteandbind-TFPAResidential-react/components/Quote/AdditionalPremisesCoverage/AdditionalPremisesCoverage';
import AdditionalInsuredCoverage from '../../../tfpa-capability-quoteandbind-TFPAResidential-react/components/Quote/AdditionalInsuredCoverage/AdditionalInsuredCoverage';
import metadata from './CoveragesAccordion.metadata.json5';
import messages from './CoveragesAccordion.messages'
import styles from './CoveragesAccordion.module.scss'


function CoveragesAccordion(props) {

    const translator = useContext(TranslatorContext);
    const intlContext = useContext(IntlContext);
    const showAdditionalFieldError = false   
    const authHeader = _.get(useAuthentication(), 'authHeader');
    const viewModelService = useContext(ViewModelServiceContext);
    const isTFPACoverageSummary = true

    const { onTabChangeObj } = props;

    let ho205CovPremiumAmount
    
    useEffect(() => {

        retrieveSubmission()

    }, [])

    const retrieveSubmission = () => {
        if (authHeader) {
            // DE16733
            ho205CovPremiumAmount = _.get(onTabChangeObj, 'latestJobPolicyPeriod.hoCoverages_TFPA.homeOfficeLiabPremium_Ext')
        }
    }

    const policyType = _.get(onTabChangeObj, 'latestJobPolicyPeriod.policyType_TFPA');

    const hideHO205CoverageSection = useCallback(() => {
        const usage = _.get(onTabChangeObj, 'latestJobPolicyPeriod.lobs.homeOwners_tfpa.dwellingDTO.homeDetails.dwellingUsage');
        // DE16381
        return policyType?.code === 'DP2' || (policyType?.code === 'HO6' && usage.code === 'rent');
    }, [onTabChangeObj])

    const getAdditionalCoverages = useCallback(() => {
        const addCov = _.get(onTabChangeObj, 'latestJobPolicyPeriod.hoCoverages_TFPA.additionalCoverages')

        return _.filter(addCov, (cov) => cov.publicID !== 'HO205')
    }, [onTabChangeObj]);

    const getByCovLabel = useCallback(() => {
        const addCov = _.find(_.get(onTabChangeObj, 'latestJobPolicyPeriod.hoCoverages_TFPA.additionalCoverages'), (cov) => cov.publicID === 'HO205')

        if (addCov && addCov.amount && !showAdditionalFieldError) {
            const formatterCurrency = intlContext.formatNumber(addCov.amount.amount, {
                style: 'currency',
                currency: addCov.amount.currency,
                // currencyDisplay: 'code',
            });

            return (<p>{`${translator(messages.ho205PremiumLabel)}`}&nbsp;&nbsp;<b>{`(Premium: ${formatterCurrency})`}</b></p>);
        }

        return translator(messages.ho205PremiumLabel)
    }, [intlContext, showAdditionalFieldError, onTabChangeObj, translator])

    const showAdditionalPremisesTfpa = useCallback(() => {
        const occupancy = _.get(onTabChangeObj, 'latestJobPolicyPeriod.lobs.homeOwners_tfpa.dwellingDTO.homeDetails.occupancy');
        if (occupancy) {
            if (occupancy.code === 'tenant' && policyType.code === 'HO6') {
                return false;
            }
        }

        if (policyType) {
            if (policyType.code === 'DP2') {
                return false;
            }
        }

        return true;
    }, [onTabChangeObj, policyType]);

    const showAdditionalPersonsTfpa = useCallback(() => {
        if (policyType?.code === 'DP2') {
            return false;
        }
        return true;
    }, [policyType]);

    // DE16262
    const renderValueField = useCallback((rowData, rowIndex) => (
        <div style={{ 'display': 'flex', 'justify-content': 'end' }}>Premium:&nbsp;&nbsp;<CurrencyField
            id={`creditAmount_${rowIndex}`}
            value={rowData.amount}
            readOnly
        /></div>
    ), []);

    const renderNameField = useCallback((rowData) => <span>{rowData.name}</span>, []);

    // DE16446 
    const renderAddlNameField = useCallback((item) => <span>{item.accountContactDTO.displayName}</span>, []);

    const renderRelationType = (item) => item.relationshipToInsured;

    const renderCoverageType = (item, rowId) => {
        const additionalInsureds = _.get(onTabChangeObj, 'latestJobPolicyPeriod.hoCoverages_TFPA.additionalInsureds_Ext');

        const selectedInsured = Array.isArray(additionalInsureds) && additionalInsureds.length > 0 ? additionalInsureds[rowId] : {};

        const coveragesArray = Array.isArray(selectedInsured.coverages) ? selectedInsured.coverages : [];

        const coverage = coveragesArray.length > 0 ? coveragesArray[0] : undefined;

        const termsArray = Array.isArray(coverage?.terms) ? coverage.terms : [];

        const term = termsArray.length > 0 ? termsArray[0] : undefined;

        const chosenTermValue = term ? term.chosenTermValue : undefined;

        return chosenTermValue;
    };

    // DE16447
    const ho5CovData = [{ description: _.get(onTabChangeObj, 'lobData.homeowners_tfpa.coverages.homeOfficeLiabDesc_Ext.value'), coverageValue: _.get(onTabChangeObj, 'lobData.homeowners_tfpa.coverages.medPayOthers_Ext.value') }]

    const renderDescription = (item) => item.description;

    const renderMedicalPayment = (item) => item.coverageValue ? 'INCLUDED' : 'NOT INCLUDED'


    const overrideProps = {
        '@field': {
            labelPosition: 'left',
        },
        sectionICoverages: {
            value: _.get(onTabChangeObj, 'latestJobPolicyPeriod.hoCoverages_TFPA.sectionICoverages_Ext'),
            visible: !_.isUndefined(onTabChangeObj),
            // eslint-disable-next-line no-secrets/no-secrets
            path: 'latestJobPolicyPeriod.hoCoverages_TFPA.sectionICoverages_Ext',
            onTabChangeObj,
            showError: false,
            isEditable: false,   //US26839
            showAmount: true,
            showCoverageNameAmount: false,
            isTFPAResidentialSummary: true,
            showAdditionalFieldError
        },
        sectionIICoverages: {
            value: _.get(onTabChangeObj, 'latestJobPolicyPeriod.hoCoverages_TFPA.sectionIICoverages_Ext'),
            visible: !_.isUndefined(onTabChangeObj),
            // eslint-disable-next-line no-secrets/no-secrets
            path: 'latestJobPolicyPeriod.hoCoverages_TFPA.sectionIICoverages_Ext',
            onTabChangeObj,
            loadingClause: false,
            showError: false,
            isEditable: false,   //US26839
            showAmount: true,
            showCoverageNameAmount: false,
            isTFPAResidentialSummary: true,
            showAdditionalFieldError
        },
        additionalCoverages: {
            value: getAdditionalCoverages(),
            visible: !_.isUndefined(onTabChangeObj),
            path: 'latestJobPolicyPeriod.hoCoverages_TFPA.additionalCoverages',
            loadingClause: false,
            onTabChangeObj,
            showError: false,
            isEditable: false,   //US26839
            showAmount: true,
            showCoverageNameAmount: false,
            isTFPAResidentialSummary: true,
            showAdditionalFieldError
        },
        exclusionsAndConditions: { // DE16271-Removed labelPosition
            value: _.get(onTabChangeObj, 'latestJobPolicyPeriod.hoCoverages_TFPA.exclusions_Ext'),
            visible: !_.isUndefined(onTabChangeObj),
            // eslint-disable-next-line no-secrets/no-secrets
            path: 'latestJobPolicyPeriod.hoCoverages_TFPA.exclusions_Ext',
            onTabChangeObj,
            loadingClause: false,
            showError: false,
            isEditable: false,   //US26839
            showAmount: true,
            showCoverageNameAmount: false,
            isTFPAResidentialSummary: true,
            showAdditionalFieldError
        },
        premium: {
            visible: true //US26839
        },
        moreAdditionalCovs: {
            visible: isTFPACoverageSummary ? false : !hideHO205CoverageSection()
        },
        ho205Fields: {
            visible: onTabChangeObj?.lobData?.homeowners_tfpa
                .coverages?.homeOfficeLiabCoverage_Ext?.value === true,
            className: isTFPACoverageSummary ? 'covSum' : 'clauseAndTermSpacing', //DE16354
        },
        describeField: {
            readOnly: isTFPACoverageSummary, //DE16354
        },
        medicalPayment: {
            readOnly: isTFPACoverageSummary  //DE16354
        },
        sectionICovPremium: {
            visible: !showAdditionalFieldError && _.get(onTabChangeObj, 'latestJobPolicyPeriod.hoCoverages_TFPA.sectionICoveragesTotal_Ext') !== undefined,
            value: _.get(onTabChangeObj, 'latestJobPolicyPeriod.hoCoverages_TFPA.sectionICoveragesTotal_Ext')
        },
        sectionIICovPremium: {
            visible: !showAdditionalFieldError && _.get(onTabChangeObj, 'latestJobPolicyPeriod.hoCoverages_TFPA.sectionIICoveragesTotal_Ext') !== undefined,
            value: _.get(onTabChangeObj, 'latestJobPolicyPeriod.hoCoverages_TFPA.sectionIICoveragesTotal_Ext')
        },
        addCovPremium: {
            visible: !showAdditionalFieldError && _.get(onTabChangeObj, 'latestJobPolicyPeriod.hoCoverages_TFPA.additionalCoveragesTotal_Ext') !== undefined,
            value: _.get(onTabChangeObj, 'latestJobPolicyPeriod.hoCoverages_TFPA.additionalCoveragesTotal_Ext')
        },
        exclCovPremium: {
            visible: !showAdditionalFieldError && _.get(onTabChangeObj, 'latestJobPolicyPeriod.hoCoverages_TFPA.exclusionsFeeTotal_Ext') !== undefined,
            value: _.get(onTabChangeObj, 'latestJobPolicyPeriod.hoCoverages_TFPA.exclusionsFeeTotal_Ext')
        },
        premiumSectionI: {
            visible: !showAdditionalFieldError && _.get(onTabChangeObj, 'latestJobPolicyPeriod.hoCoverages_TFPA.sectionICoveragesTotal_Ext') !== undefined
        },
        premiumSectionII: {
            visible: !showAdditionalFieldError && _.get(onTabChangeObj, 'latestJobPolicyPeriod.hoCoverages_TFPA..coverages.sectionIICoveragesTotal_Ext') !== undefined
        },
        premiumSectionAdd: {
            visible: !showAdditionalFieldError && _.get(onTabChangeObj, 'latestJobPolicyPeriod.hoCoverages_TFPA.additionalCoveragesTotal_Ext') !== undefined,
        },
        premiumSectionExclusion: {
            visible: !showAdditionalFieldError && _.get(onTabChangeObj, 'latestJobPolicyPeriod.hoCoverages_TFPA.exclusionsFeeTotal_Ext') !== undefined,
        },
        ho205Cov: {
            label: getByCovLabel(),
            readOnly: isTFPACoverageSummary //DE16354
        },
        AddlInsCoverageTable: {
            onTabChangeObj,
            authHeader,
            visible: showAdditionalPersonsTfpa() && !_.isNull(onTabChangeObj) && !isTFPACoverageSummary
        },
        AddPrmsCoverageTable: {
            onTabChangeObj,
            visible: showAdditionalPremisesTfpa() && !_.isNull(onTabChangeObj) && !isTFPACoverageSummary
        },
        discountSurcharges: {
            data: _.get(onTabChangeObj, 'latestJobPolicyPeriod.hoCoverages_TFPA.discountsSurchargesAndFees_Ext'),
            visible: isTFPACoverageSummary ? true : !showAdditionalFieldError &&
                true//_.get(offeredQuote, 'premium.total') !== undefined
        },
        discountPremium: {
            value: _.get(onTabChangeObj, 'latestJobPolicyPeriod.hoCoverages_TFPA.discountSurchargeFeeTotal_Ext')
        },
        discountSurchargesTitle: {
            visible: isTFPACoverageSummary ? true : !showAdditionalFieldError &&
                true//_.get(offeredQuote, 'premium.total') !== undefined
        },
        additionalCoveragesTitle: {
            visible: !_.isEmpty(_.get(onTabChangeObj, 'latestJobPolicyPeriod.hoCoverages_TFPA.additionalCoverages'))
        },
        sectionICoveragesTitle: {
            visible: !_.isEmpty(_.get(onTabChangeObj, 'latestJobPolicyPeriod.hoCoverages_TFPA.sectionICoverages_Ext'))
        },
        sectionIICoveragesTitle: {
            visible: !_.isEmpty(_.get(onTabChangeObj, 'latestJobPolicyPeriod.hoCoverages_TFPA.sectionIICoverages_Ext'))
        },
        // DE16446
        addlInsuredTitle: {
            visible: isTFPACoverageSummary && _.get(onTabChangeObj, 'latestJobPolicyPeriod.hoCoverages_TFPA.additionalInsureds_Ext')?.length > 0
        },
        additionalInsuredCoveragesTable: {
            data: _.get(onTabChangeObj, 'latestJobPolicyPeriod.hoCoverages_TFPA.additionalInsureds_Ext'),
            visible: isTFPACoverageSummary && _.get(onTabChangeObj, 'latestJobPolicyPeriod.hoCoverages_TFPA.additionalInsureds_Ext')?.length > 0
        },
        // DE17556
        addlInsuredPremium: {
            value: _.get(onTabChangeObj, 'latestJobPolicyPeriod.hoCoverages_TFPA.additionalInsuredsTotal_Ext')
        },
        // DE1644
        ho205CovTitle: {
            visible: true && !_.isUndefined(ho205CovPremiumAmount)
        },
        ho205CoveragesTable: {
            data: ho5CovData,
            visible: true && !_.isUndefined(ho205CovPremiumAmount)
        },
        ho205CovPremium: {
            value: _.get(onTabChangeObj, 'latestJobPolicyPeriod.hoCoverages_TFPA.homeOfficeLiabPremium_Ext')
        },
        discountSection:{
            visible:_.some(_.get(onTabChangeObj,'latestJobPolicyPeriod.hoCoverages_TFPA.discountsSurchargesAndFees_Ext'),(amt)=> amt.amount)
        },
        creditValue:{
            visible :_.some(_.get(onTabChangeObj,'latestJobPolicyPeriod.hoCoverages_TFPA.discountsSurchargesAndFees_Ext'),(amt)=> amt.amount)
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            clausesComponentVM: ClausesComponentVM,
            AddlInsCoverage: AdditionalInsuredCoverage,
            AddPrmsCoverage: AdditionalPremisesCoverage
        },
        resolveCallbackMap: {
            renderCreditName: renderNameField,
            renderCreditValue: renderValueField,
            renderAddlNameField,
            renderRelationType,
            renderCoverageType,
            renderDescription,
            renderMedicalPayment
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={onTabChangeObj}
            overrideProps={overrideProps}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
            callbackMap={resolvers.resolveCallbackMap}
        />
    );
}

CoveragesAccordion.propTypes = {
    data: PropTypes.shape({}).isRequired,
};

export default CoveragesAccordion;
